

<div class="footerFlex">

	<div style="display: flex; flex-flow: row nowrap; gap: 1em; justify-content: center;">
		<a [routerLink]="['/Impressum_']" style="color: #0000009d;">Impressum</a>
		|
		<a [routerLink]="['/Kontakt_']" style="color: #0000009d;">Kontakt</a>
		|
		<a [routerLink]="['/Datenschutzerklärung_']" style="color: #0000009d;">Datenschutz</a>
        @if( environment.features.payments ) {
		|
        <a [routerLink]="['/auth/plans']" style="color: #0000009d;">Preise</a>
		}
	</div>


	<div style="display: flex; justify-content: center; gap: 2em;">
		<img src="assets/logo_trivelope.png" style="height: 20px;" />
		<div>
			Mitgliederportal v{{version}}
			developed with <span style="color:black;">♡</span> by trivelope GmbH,
			<a style="color: #000000b3" href="mailto:info@trivelope.de">info&#64;trivelope.de</a>,
			<a style="color: #000000b3" href="https://www.trivelope.de">www.trivelope.de</a>
		</div>

	</div>

</div>
